import Box from "@mui/material/Box";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Modal} from "@buildwitt/shapeshift-common/v2/modal";
import {Paper, Typography} from "@mui/material";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import {Link} from "react-router-dom";
import useDevCycleSdk from "@/app2/shared/hooks/useDevCycleSdk";

interface IProps {
	open: boolean,
	onClose: (reload?: boolean) => void,
}

const useStyles = makeStyles()((theme) => ({
	adminQuickCreateModal: {
		"[class*='modalExpand']": {
			display: "none"
		},
		"[class*='modalIcons']": {
			top: 26,
			right: 26,
			color: `${theme.palette.text.primary}`,
			opacity: 0.56
		},
		"[class*='contentContainer']": {
			maxWidth: `calc(100% - ${theme.spacing(3)})`,
			width: "600px"
		}
	},
	modalContent: {
		padding: 0,
		display: "flex",
		flexDirection: "column"
	},
	title: {
		height: "72px",
		padding: theme.spacing(0, 3),
		borderBottom: `1px solid ${theme.palette.divider}`,
		display: "flex",
		alignItems: "center"
	},
	actions: {
		padding: theme.spacing(3, 0, 6),
		width: "374px",
		maxWidth: `calc(100% - ${theme.spacing(3)})`,
		alignSelf: "center",
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: "center",
		rowGap: theme.spacing(3),
		columnGap: theme.spacing(3),
		"& > *": {
			width: `calc(50% - ${theme.spacing(1.5)})`
		}
	},
	action: {
		borderRadius: theme.borderRadius.small,
		"&:active, &:focus": {
			outline: `2px solid ${theme.palette.primary.main}`,
			color: theme.palette.primary.main,
			".MuiPaper-root": {
				backgroundColor: `${theme.palette.primary.main}14`
			},
			"& svg, & span": {
				color: theme.palette.primary.main
			}
		}
	},
	actionContent: {
		padding: theme.spacing(3, 2),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		textAlign: "center",
		cursor: "pointer"
	}
}));

export const AdminQuickCreateModal: FC<IProps> = ({open, onClose}) => {
	const {classes} = useStyles();
	const {playlists, announcements} = useDevCycleSdk();

	return (
		<Modal
			open={open}
			onClose={() => onClose()}
			aria-labelledby="modal-modal-title"
			title="Select Option"
			aria-describedby="modal-modal-description"
			className={classes.adminQuickCreateModal}
		>
			<Box className={classes.modalContent}>
				<Typography variant="h6" className={classes.title}>
					Select Option
				</Typography>
				<Box className={classes.actions}>
					{playlists && <Link to="/admin/playlists/create" onClick={() => onClose()} className={classes.action}>
						<Paper elevation={3} className={classes.actionContent} role="button" tabIndex={0}><PlaylistPlayIcon /><span>Playlist</span></Paper>
					</Link>}
					<Link to="/admin/courses/create-new" onClick={() => onClose()} className={classes.action}>
						<Paper elevation={3} className={classes.actionContent} role="button"><MenuBookIcon /><span>Course</span></Paper>
					</Link>
					<Link to="/admin/lessons/create-new" onClick={() => onClose()} className={classes.action}>
						<Paper elevation={3} className={classes.actionContent} role="button"><PlayCircleFilledWhiteOutlinedIcon /><span>Lesson</span></Paper>
					</Link>
					<Link to="/admin/quizzes/create" onClick={() => onClose()} className={classes.action}>
						<Paper elevation={3} className={classes.actionContent} role="button"><QuizOutlinedIcon /><span>Quiz</span></Paper>
					</Link>
					{announcements && <Link to="/admin/announcements/create" onClick={() => onClose()} className={classes.action}>
						<Paper elevation={3} className={classes.actionContent} role="button"><CampaignOutlinedIcon /><span>Announcement</span></Paper>
					</Link>}
				</Box>
			</Box>
		</Modal>
	);
}